module.exports = __webpack_public_path__ + "static/media/parking.faaff997.svg";